import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "paymentOptions" }
const _hoisted_2 = { class: "paymentOptions-item-icon" }
const _hoisted_3 = { class: "paymentOptions-item-text" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "caption-small" }
const _hoisted_6 = {
  key: 0,
  class: "paymentOptions-item-btn"
}
const _hoisted_7 = {
  key: 1,
  class: "paymentOptions-item-btn"
}
const _hoisted_8 = { class: "paymentOptions-item-icon" }
const _hoisted_9 = { class: "paymentOptions-item-text" }
const _hoisted_10 = { class: "h3" }
const _hoisted_11 = { class: "caption-small" }
const _hoisted_12 = {
  key: 0,
  class: "paymentOptions-item-btn"
}
const _hoisted_13 = {
  key: 1,
  class: "paymentOptions-item-btn"
}

import { ref, onMounted } from "vue";
import BaseModal from "@/components/base/BaseModal.vue";
import { getLocalStorageParams, setLocalStorageParams } from "@/utils/common";
import router from "@/router";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentModal',
  props: {
  showModal: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {


const emits = __emit;

const { t } = useI18n();

const activePaymentOption = ref<"card" | "sber">("card");

const closeModal = () => emits("close");
const selectMethods = () => {
  setLocalStorageParams("paymentMethod", activePaymentOption.value);
  closeModal();
  router.push("payment");
};

onMounted(() => {
  if (getLocalStorageParams("paymentMethod")) {
    activePaymentOption.value = getLocalStorageParams("paymentMethod") as
      | "card"
      | "sber";
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.showModal)
    ? (_openBlock(), _createBlock(BaseModal, {
        key: 0,
        title: _unref(t)('payment.modal.title'),
        "main-btn-title": _unref(t)('payment.modal.continue'),
        onAction: selectMethods,
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "paymentOptions-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activePaymentOption.value = 'card'))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(BaseFigureForIcon, {
                  icon: "card-pay",
                  color: "grey-secondary",
                  size: "medium"
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("payment.modal.cardTitle")), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("payment.modal.cardSubtitle")), 1)
              ]),
              (activePaymentOption.value === 'sber')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "#CCD3DC"
                      }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "6",
                        fill: "#F2F4F6"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (activePaymentOption.value === 'card')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "#CCD3DC"
                      }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "6",
                        fill: "#2E3066"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "paymentOptions-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (activePaymentOption.value = 'sber'))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(BaseFigureForIcon, {
                  icon: "sber-pay",
                  folder: "payments",
                  color: "grey-secondary",
                  "is-original-color": "",
                  size: "medium"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("payment.modal.otherMethodTitle")), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("payment.modal.sberSubtitle")), 1)
              ]),
              (activePaymentOption.value === 'card')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "#CCD3DC"
                      }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "6",
                        fill: "#F2F4F6"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (activePaymentOption.value === 'sber')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[5] || (_cache[5] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "#CCD3DC"
                      }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "6",
                        fill: "#2E3066"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "main-btn-title"]))
    : _createCommentVNode("", true)
}
}

})